import React, { useState } from 'react'
import { ICallFlowStep } from '@dataTypes/clinic.type'
import { RichTextEditor } from '@enamelai/design-system'
import { smsMessagePair } from '@utils/communicationFlow.util'
import StepPanelShell from './StepPanelContainer.component'

type SendSmsStep = Extract<ICallFlowStep, { type: 'send_sms' }>

export type SendSmsPanelProps = {
  step: SendSmsStep
  branchLabel: string
  title?: string
  onChange: (patch: Partial<SendSmsStep>) => void
  onCancel: () => void
  onDone: () => void
}

const SendSmsPanel = ({
  step,
  branchLabel,
  title = 'Send SMS',
  onChange,
  onCancel,
  onDone,
}: SendSmsPanelProps): React.ReactElement => {
  const [error, setError] = useState<string | null>(null)
  const editorValue = step.messageHtml ?? step.message ?? ''

  return (
    <StepPanelShell
      title={title}
      branchLabel={branchLabel}
      onCancel={onCancel}
      onDone={() => {
        const pair = smsMessagePair(step.messageHtml, step.message)
        if (!pair.message) {
          setError('Enter a message.')
          return
        }
        onChange({
          messageHtml: pair.messageHtml,
          message: pair.message,
        })
        onDone()
      }}
    >
      <div className="scp-sms-message-field">
        <span className="ds-input-field__label">Enter greeting message</span>
        <RichTextEditor
          variant="sms-notes"
          value={editorValue}
          placeholder="Type your message here"
          bodyActions={[]}
          footerActions={[]}
          aiEnabled={false}
          onChange={(next) => {
            setError(null)
            const pair = smsMessagePair(next, undefined)
            onChange({
              messageHtml: pair.messageHtml,
              message: pair.message || undefined,
            })
          }}
        />
        {error ? <p className="scp-step-panel-muted">{error}</p> : null}
      </div>
    </StepPanelShell>
  )
}

export default SendSmsPanel
